import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 4H8v7c0 .23.02.453.055.67l.12.707.36.622a4.005 4.005 0 002.796 1.946l.67.112.669-.113c1.19-.2 2.208-.929 2.796-1.945l.36-.622.118-.707c.037-.217.056-.44.056-.67V4zm2.011 10H18l-.803.001-.004.007A6.005 6.005 0 0113 16.917L13 19a1 1 0 001 1h2a1 1 0 110 2H8a1 1 0 110-2h2a1 1 0 001-1v-2.083a6.005 6.005 0 01-4.193-2.91l-.004-.006L6 14h-.011A4 4 0 012 10V6c0-1.1.9-2 2-2h2c0-1.1.9-2 2-2h8a2 2 0 012 2h2a2 2 0 012 2v4a4 4 0 01-3.989 4zM6.083 12c0 .001 0 0 0 0H6a2.004 2.004 0 01-2-2V6h2v5a6.093 6.093 0 00.083 1zm11.834 0A6.006 6.006 0 0018 11V6h2v4a2 2 0 01-2 2h-.083z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
